import { RodeoEvent } from "model/rodeoEvent";

export const groupBy = <T>(list: T[], keyGetter: (value: T) => any): { [id: string]: T[] } => {
    const map = {};
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map[key];
        if (!collection) {
            map[key] = [item];
        } else {
            collection.push(item);
        }
    });
    return map;
}

export const getRunSecondValue = (rodeoEvent: RodeoEvent, obj: any) => {
    let secondDisplayValue = '';
    const valuesToDisplay = rodeoEvent.configuration.runs.slotTwoFieldName.split('+');
    valuesToDisplay.forEach(value => {
        secondDisplayValue += value.split('.').reduce((o, i) => o[i], obj) + ' '; 
    });
    return secondDisplayValue;
} 


// WEBPACK FOOTER //
// ./src/lib/helpers.ts